var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loading-spinner" }, [
    _c(
      "svg",
      { attrs: { id: "load", x: "0px", y: "0px", viewBox: "0 0 150 150" } },
      [
        _c("circle", {
          attrs: { id: "loading-inner", cx: "75", cy: "75", r: "60" }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-544cf08e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-544cf08e","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/spinner.vue
// module id = 69
// module chunks = 0